import { ResourceEnum } from "src/constants/constants.ts";
import type { TFunction } from "i18next";
import React from "react";
import type { Module } from "src/system/module.types.ts";
import type { AccountingAccountResource } from "@exonn/js-sdk/src/namespaces/accounting-account";

export const module: Module<AccountingAccountResource> = {
  id: ResourceEnum.AccountingAccount,
  bigIcon: <span className={"icon-20-invoices"} />,
  smallIcon: <span className={"icon-15-invoices"} />,
  name: (t: TFunction) => t("moduleName.accounting-account"),
  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
